module.exports = __webpack_public_path__ + "img/check-mark.5c498027.svg";